import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../api';
import { useAuth } from '../auth';
import { ErrorBox } from '../ui';

/**
 * Вход сотрудника. Два способа: пароль (оператор за компьютером) и код на
 * телефон (водитель, который пароль не помнит и вводить его в машине не будет).
 */
export function StaffLogin() {
  const { login, me } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState<'password' | 'sms'>('password');
  const [loginValue, setLoginValue] = useState('admin@watercrm.local');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [sent, setSent] = useState<{ devCode?: string; channel?: string; retryAfterSec?: number } | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  if (me?.scope === 'staff') nav('/', { replace: true });

  const go = async (fn: () => Promise<{ token: string; scope: string; user?: { role: string } }>) => {
    setBusy(true);
    setError(null);
    try {
      const res = await fn();
      await login(res.token, res.scope);
      nav(res.user?.role === 'DRIVER' ? '/driver' : '/', { replace: true });
    } catch (e) {
      setError(e instanceof ApiError ? e : new Error('Не получилось войти'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <img className="logo" src="/logo.png" alt="Логотип компании" />
      <div className="card">
        <div className="tabs">
          <button className={mode === 'password' ? 'active' : ''} onClick={() => setMode('password')}>
            По паролю
          </button>
          <button className={mode === 'sms' ? 'active' : ''} onClick={() => setMode('sms')}>
            По коду из SMS
          </button>
        </div>

        {mode === 'password' ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              void go(() => api('/auth/login', { body: { login: loginValue, password } }));
            }}
          >
            <div className="field">
              <label>Телефон или почта</label>
              <input value={loginValue} onChange={(e) => setLoginValue(e.target.value)} autoComplete="username" />
            </div>
            <div className="field">
              <label>Пароль</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>
            <button className="primary big" style={{ width: '100%' }} disabled={busy}>
              Войти
            </button>
          </form>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (!sent) {
                setBusy(true);
                void api<{ channel: string; devCode?: string }>('/auth/otp/request', { body: { phone } })
                  .then((r) => setSent(r))
                  .catch(setError)
                  .finally(() => setBusy(false));
              } else {
                void go(() => api('/auth/otp/verify', { body: { phone, code, scope: 'staff' } }));
              }
            }}
          >
            <div className="field">
              <label>Телефон</label>
              <input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+7 902 500-00-11"
                inputMode="tel"
              />
            </div>
            {sent ? (
              <div className="field">
                <label>Код из сообщения</label>
                <input value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" autoFocus />
                {sent.devCode ? (
                  <div className="ok">Стенд: код {sent.devCode} (канал: {sent.channel})</div>
                ) : sent.retryAfterSec ? (
                  <div className="muted">
                    Код уже отправлен, введите его. Новый — через {sent.retryAfterSec} сек.
                  </div>
                ) : (
                  <div className="muted">Отправлено, канал: {sent.channel ?? 'SMS'}</div>
                )}
              </div>
            ) : null}
            <button className="primary big" style={{ width: '100%' }} disabled={busy}>
              {sent ? 'Войти' : 'Выслать код'}
            </button>
          </form>
        )}

        <ErrorBox error={error} />
        <div className="muted" style={{ marginTop: 16, fontSize: 12 }}>
          Стенд: admin@watercrm.local / admin123 · водитель +7 902 500-00-11
        </div>
      </div>
    </div>
  );
}
